import { render, staticRenderFns } from "./week.vue?vue&type=template&id=6c38f24c&scoped=true&"
import script from "./week.vue?vue&type=script&lang=js&"
export * from "./week.vue?vue&type=script&lang=js&"
import style0 from "./week.vue?vue&type=style&index=0&id=6c38f24c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c38f24c",
  null
  
)

export default component.exports